import { memo } from "react";
import Details from "../Details";
import UserInfo from "../UserInfo";
import { StyledAppointmentWrapper } from "./styled";

const AppointmentWrapper = () => {
  return (
    <StyledAppointmentWrapper>
      <UserInfo />
      <Details />
    </StyledAppointmentWrapper>
  );
};

export default memo(AppointmentWrapper);